'use client';

import { GlobalProvider } from '@/components/providers';
import { usePathname } from 'next/navigation';
import { Toaster } from '@fileverse/ui';
export default function LayoutProvider({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const pathname = usePathname();
  const staticPages = ['/about', '/tos', '/privacy-policy', '/acceptable-use'];
  return (
    <>
      {staticPages.includes(pathname) ? (
        children
      ) : (
        <GlobalProvider>
          {children}
          <Toaster position="bottom-right" duration={3000} />{' '}
        </GlobalProvider>
      )}
    </>
  );
}
